import { createContext } from "react"

import type { Application } from "./application"
import type { ApplicationScope } from "./plugin-runtime"

export const ApplicationContext = createContext<Application | null>(null)
export const ApplicationScopeContext = createContext<ApplicationScope | null>(null)
